export const readMore = "Read More";
export const followManual = "Please follow our manual";
export const disabledMessage =
  "To enable this functionality, please contact us at: " +
  '<a href="mailto:support@quotiss.com">support@quotiss.com</a>';

export const onboarding = {
  createdClients: {
    title: "Create new Account",
    steps: [
      "In order to let you start working with the system, we imported 3 sample accounts, you can remove them or add new ones.",
    ],
    buttons: {
      mainButton: {
        label: "Add new Account",
        callMethod: "openClientAddForm",
      },
      moreButton: {
        label: readMore,
        url: "http://quotiss.groovehq.com/knowledge_base/topics/how-to-add-new-client",
      },
    },
  },
  createdQuotes: {
    title: "Create new FCL Quote",
    steps: [
      "It’s easy, you can just select account, origin destination locations and desired rate",
    ],
    mailTo: "no-reply@quotiss.com",
    buttons: {
      mainButton: {
        label: "Add new Quote",
        callMethod: "openQuoteForm",
      },
      moreButton: {
        label: readMore,
        url: "http://quotiss.groovehq.com/knowledge_base/topics/how-to-send-an-offer-to-one-client",
      },
    },
  },
  updatedDashboard: {
    title: "Check your dashboard",
    steps: [
      "Quotiss provides several metrics which allow you to monitor your team performance. " +
        "You may analyse the data in various periods",
    ],
    buttons: {
      moreButton: {
        label: readMore,
        url: "http://quotiss.groovehq.com/knowledge_base/topics/what-is-dashboard",
      },
    },
  },
};
